<template>
    <div class="conference info-box is-card">
        <div class="box-main">
            <div class="box-icon is-hidden-touch">
                <i class="fad fa-presentation has-text-primary fa-2x"></i>
            </div>
            <div class="box-body">
                <div class="card-title">
                    <i class="fad fa-presentation has-text-primary is-hidden-desktop mr-2"></i>{{ conference.title }}
                </div>
                <div class="card-meta" v-if="conference.provider">{{ conference.provider }}</div>
                <div class="card-meta">
                    <span><i class="far fa-fw fa-calendar-week mr-1"></i>{{ confDates }}</span>
                    <span v-if="conference.location" class="ml-3"><i class="far fa-fw fa-location-dot mr-1"></i>{{ conference.location }}</span>
                </div>
                <!-- The one chip worth keeping: the window/registered states are
                     already said by the footer line and the alert -->
                <div class="card-chips mt-2" v-if="!registrationOpen">
                    <status-chip label="Registration closed" type="warning" icon="fa-ban"/>
                </div>
            </div>
        </div>

        <div class="box-alert" v-if="conference.registered">
            <i class="fas fa-fw fa-circle-info mr-2"></i>You are registered for this conference. Find it under your Conference Records.
        </div>

        <div class="box-actions">
            <div class="box-lead box-info" v-if="registrationText"><i class="far fa-fw fa-calendar-check mr-2"></i>{{ registrationText }}</div>
            <div class="box-buttons">
                <!-- One registration per conference: registered students get
                     their record, everyone else gets Register (disabled once
                     registration has closed) -->
                <b-button v-if="conference.registered && conference.registration_id" tag="router-link" :to="{name: 'conference', params: {registrationId: conference.registration_id}}" type="is-primary" size="is-small"><i class="fas fa-screen-users mr-2"></i>View Record</b-button>
                <b-button v-else tag="router-link" :to="{name: 'register', params: {confId: conference.id}}" type="is-primary" size="is-small" :disabled="!registrationOpen"><i class="fas fa-arrow-right mr-2"></i>Register</b-button>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import StatusChip from "./framework/StatusChip";
    import {formatDateRange} from "../utils/dates";

    /**
     * Conference Center card (global .info-box.is-card anatomy): when the
     * event runs, whether registration is open (footer line), and whether
     * this student already holds a registration (the list API sends
     * `registered` + `registration_id`). No status chips: the footer line
     * and the alert already say everything they would.
     */
    export default {
        name: "Conference",
        components: {StatusChip},
        props: {
            conference: {
                required: true
            }
        },
        computed: {
            confDates() {
                return formatDateRange(this.conference.start_at, this.conference.end_at);
            },
            registrationOpen() {
                return moment().isBetween(this.conference.open_at, this.conference.close_at);
            },
            registrationText() {
                const c = this.conference;
                if (this.registrationOpen && c.close_at) return 'Registration open through ' + moment(c.close_at).format('MMMM Do, YYYY');
                if (!this.registrationOpen && c.open_at && moment().isBefore(c.open_at)) return 'Registration opens ' + moment(c.open_at).format('MMMM Do, YYYY');
                if (!this.registrationOpen && c.close_at) return 'Registration closed ' + moment(c.close_at).format('MMMM Do, YYYY');
                return '';
            }
        }
    };
</script>

<style lang="scss" scoped>
    // Layout comes from the global .info-box.is-card (assets/scss/_cta.scss)
    .card-title {
        font-weight: 700;
        line-height: 1.3;
    }

    .card-meta {
        font-size: 0.85rem;
        color: #7a7a7a;
    }

    .card-chips {
        display: flex;
        flex-wrap: wrap;
        gap: 0.4rem;
    }
</style>
